module.exports = __webpack_public_path__ + "static/media/logo-funtravia.52cdb66e.svg";